import { render } from "./MantList.vue?vue&type=template&id=598c03c3"
import script from "./MantList.vue?vue&type=script&lang=js"
export * from "./MantList.vue?vue&type=script&lang=js"

import exportComponent from "D:\\fromUbuntu2\\fromUbuntu\\ferraro\\ferraro_frontend\\node_modules\\.pnpm\\vue-loader@16.8.3_webpack@4.46.0\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__